import ViewControlsToggleButton from './ViewControlsToggleButton';

export default ViewControlsToggleButton;